export default "__VITE_PUBLIC_ASSET__5b8b9ab8__"